import "./style.scss";
import ReportFrame from "../reportFrame";
import {FaList} from "react-icons/fa";
import iconEvaluated from "./icon_evaluated.png";
import React from "react";

const Index = (props) => {
  const {
    reportInfo,
    activeReport,
    onReportClear,
    reportType,
    backToLabel,
    pdfReport
  } = props;

  let embedSrc = null;

  if (reportInfo.pdfReport) {
    embedSrc = window.URL.createObjectURL(pdfReport);
  } else {
    embedSrc = reportInfo.embedFile;
  }

  function clearReport() {
    if (reportInfo.pdfReport) {
      window.URL.revokeObjectURL(embedSrc);
    }

    onReportClear();
  }

  const reportComponent = (reportInfo.useEmbedFile) ? <embed src={embedSrc} width="1255" height="1150"/>
    : <ReportFrame title={reportInfo.title} url={activeReport.reportUrl} />;

  return (<div className='show-report-content'>
    <div className='clear-report-header'>
      <div className='report-buttons'>
        <button className='clear-report-button' onClick={() => clearReport()}><FaList /> Back to {(backToLabel) ? backToLabel : 'Reports'}</button>
      </div>
      {(reportType && reportType !== 'Sample') ? <div className='report-verified'>
        <img src={iconEvaluated} alt='Approved'/> UC Evaluated
      </div> : ''}
    </div>
    <div className='show-report-body'>
      {reportInfo?.title && (reportInfo.useEmbedFile || activeReport?.reportUrl) ? (
        reportComponent
      ) : (
        <div className='error-message'>
          <p>Error: Report data is incomplete or missing.</p>
        </div>
      )}
    </div>    
  </div>
      );
}

export default Index;